import createReturnMixin from './createReturnMixin'

export default createReturnMixin({
  returnPath: '/members',
  clearMutations: ['departments/clearReturnMember'],
  showButtonKey: 'showMembersReturnButton',
  visibilityGetter: (state) => !!state.departments.returnMember,
  goBackMethodName: 'goBackToMembers',
})
